import React from 'react';
import { styled } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { formatCompact12HourTime, formatShortWeekdayMonthDay } from 'shared/Dates';
import { Colors } from 'library';
import { Card, Row, Stack, Text } from 'library/ui';
import { PermissionType, useUserContext } from 'UserContext';
import { AvailableTeacher } from 'models';

export default function Availability({
    teacher,
    requestToBook,
}: {
    teacher: AvailableTeacher;
    requestToBook: (teacher: AvailableTeacher, lower: string, upper: string, timezone?: string) => void;
}) {
    const { hasPermission } = useUserContext();
    const canPostJobs = hasPermission(PermissionType.PostJob);

    return (
        <Row gap="sm" align="stretch">
            {teacher.sub_availability.map((availability) => {
                const content = (
                    <Stack gap="sm" fullHeight justify="between">
                        <Stack gap="none">
                            <Text weight="bold">{formatShortWeekdayMonthDay(availability.timeslot.lower)}</Text>
                            <Text size="sm" tone="secondary">
                                {formatCompact12HourTime(availability.timeslot.lower, availability.timezone)}-
                                {formatCompact12HourTime(availability.timeslot.upper, availability.timezone)}
                            </Text>
                        </Stack>
                        {canPostJobs && (
                            <Row gap="none" align="center">
                                <Text tone="accent" weight="semibold" size="sm">
                                    Book
                                </Text>
                                <ChevronRight sx={{ fontSize: 16, color: Colors.secondary }} />
                            </Row>
                        )}
                    </Stack>
                );

                return (
                    <Slot key={availability.id}>
                        {canPostJobs ? (
                            <Card
                                tone="muted"
                                padding="xs"
                                fullHeight
                                onClick={() =>
                                    requestToBook(
                                        teacher,
                                        availability.timeslot.lower,
                                        availability.timeslot.upper,
                                        availability.timezone,
                                    )
                                }
                            >
                                {content}
                            </Card>
                        ) : (
                            <Card padding="sm" fullHeight tone="muted">
                                {content}
                            </Card>
                        )}
                    </Slot>
                );
            })}
        </Row>
    );
}

const Slot = styled('div')({
    width: 116,
    flexShrink: 0,
});
